import { Typography } from "@mui/material";
import PropTypes from "prop-types";

/**
 * SectionHeader — the small uppercase label that heads a content section in the
 * click-dummy (10px / 600 / uppercase / muted). Renders the `sectionLabel`
 * typography variant so the rule lives in one place.
 */
export default function SectionHeader({ children, sx }) {
  return (
    <Typography variant="sectionLabel" component="p" sx={sx}>
      {children}
    </Typography>
  );
}

SectionHeader.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};
